import axios from "axios";
import { FETCH_ALL_STOCK_API } from "../Constants/Apis";

export const getStocks = async () => {
  try {
    return axios.get(FETCH_ALL_STOCK_API);
  } catch (e) {
    return console.log(e);
  }
};

export const getStocksByBarcodeCC = async (barcode, counterCode) => {
  try {
    return axios.get(`${FETCH_ALL_STOCK_API}/by-counter-barcode?barcode=${barcode}&counterCode=${counterCode}`);
  } catch (e) {
    return console.log(e);
  }
};

export const createStock = async (payload) => {
  try {
    return axios.post(FETCH_ALL_STOCK_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateStock = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_STOCK_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateSku = async (payload) => {
  try {
    return axios.put(`${FETCH_ALL_STOCK_API}/update-sku`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateProductType = async (payload) => {
  try {
    return axios.put(`${FETCH_ALL_STOCK_API}/update-pt`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteStock = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_STOCK_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

export const mutateStock = async (payload) => {
  try {
    return axios.post(`${FETCH_ALL_STOCK_API}/mutate`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateStockQuantity = async (payload) => {
  try {
    return axios.put(`${FETCH_ALL_STOCK_API}/update-quantity`, payload);
  } catch (e) {
    return console.log(e);
  }
};


export const patchIntersectStocks = async (original, next) => {
  // original: { noSJ, counterCode }
  // next:     { noSJ, counterCode, status }
  try {
    return axios.post(`${FETCH_ALL_STOCK_API}/intersect-patch`, {
      original,
      next,
    });
  } catch (e) {
    return console.log(e);
  }
};

export const getStocksNotInOpname = async ({ current = 1, pageSize = 10, counterCode } = {}) => {
  try {
    const params = { current, pageSize };
    if (counterCode) params.counterCode = counterCode;
    return axios.get(`${FETCH_ALL_STOCK_API}/not-in-opname`, { params });
  } catch (e) {
    return console.log(e);
  }
};

export const getOpnameSummary = async () => {
  try {
    return axios.get(`${FETCH_ALL_STOCK_API}/opname-summary`);
  } catch (e) {
    return console.log(e);
  }
};

export const getConsignmentType = async (barcode, counterCode) => {
  try {
    const url = `${FETCH_ALL_STOCK_API}/consignment-type?barcode=${encodeURIComponent(barcode)}${counterCode ? `&counterCode=${encodeURIComponent(counterCode)}` : ""}`;
    return axios.get(url);
  } catch (e) {
    return console.log(e);
  }
};